<template>
    <div class="exposure-chart-wrapper">
        <span
            class="ml-2"
            style="font-size: 13px; font-weight: normal; display: inline-block"
        >
            {{ $t("monitor.exposureChart.top") }}
            <v-select
                :items="topSelection"
                dense
                class="pl-1 pb-2"
                offset-y
                hide-details
                style="display: inline-block; font-size: 13px; max-width: 60px"
                v-model="topNumber"
            >
            </v-select>
        </span>
        <div ref="exposureChart" class="chart"></div>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState("Home", ["exposureData"]),
    },
    watch: {
        exposureData(nv) {
            this.processData(nv);
        },
        topNumber() {
            this.processData(this.exposureData);
        },
    },
    data() {
        return {
            topSelection: [10, 20],
            topNumber: 10,
            noDataMessage: "No Data Available",
            chart: Object,
            apiResult: [],
            broker: "",
            option: {
                title: {
                    text: "",
                    left: "center",
                    top: "center",
                    textStyle: { color: "#fff" },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid: {
                    left: 20,
                    right: 20,
                    top: 10,
                    bottom: 10,
                    containLabel: true,
                },
                xAxis: {
                    type: "value",
                    position: "top",
                    axisLabel: {
                        show: true,
                        color: "#fff",
                        formatter: (data) => {
                            return data;
                        },
                    },
                    splitLine: { lineStyle: { type: "dashed" }, show: false },
                    axisLabel: {
                        color: "#fff",
                        formatter: function (value, index) {
                            let data = value;

                            if (Math.abs(value) > 1000000) {
                                data = (value / 1000000).toFixed(0) + "M";
                                return data;
                            } else if (Math.abs(value) >= 1000) {
                                data = (value / 1000).toFixed(0) + "K";
                                return data;
                            } else if (Math.abs(value) < 1000) {
                                data = value;
                                return data;
                            }
                            return value;
                        },
                    },
                },
                yAxis: {
                    type: "category",
                    axisLine: { show: false },
                    axisLabel: {
                        show: true,
                        color: "#fff",
                        interval: 0,
                        margin: 20,
                    },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    data: [],
                },
                series: [
                    {
                        name: this.$t("common.table.exposure"),
                        type: "bar",
                        stack: "Total",
                        label: {
                            show: true,
                            formatter: function (a, b, c) {
                                const result = [];
                                let counter = 0;
                                const numArray = a.data.toString().split(".");
                                const num = numArray[0];
                                let newStr = "";

                                if (Math.abs(a.data) > 1000000) {
                                    return (
                                        (a.data / 1000000)
                                            .toFixed(2)
                                            .toString() + " M"
                                    );
                                } else if (Math.abs(a.data) > 100000) {
                                    return (
                                        (a.data / 1000).toFixed(2).toString() +
                                        " K"
                                    );
                                } else if (Math.abs(a.data) > 10000) {
                                    return (
                                        (a.data / 1000).toFixed(2).toString() +
                                        " K"
                                    );
                                }

                                for (let i = num.length - 1; i >= 0; i--) {
                                    counter++;
                                    result.unshift(num[i]);
                                    if (!(counter % 3) && i != 0) {
                                        result.unshift(",");
                                    }
                                }

                                if (numArray.length > 1) {
                                    newStr = result.join("");
                                    newStr += "." + numArray[1];
                                    return newStr;
                                } else {
                                    return result.join("");
                                }
                            },
                            color: "#fff",
                        },
                        itemStyle: {
                            color: (data) => {
                                if (data.value > 0) return "#2c69ab";
                                if (data.value < 0) return "#c82c20";
                            },
                        },
                        data: [],
                    },
                ],
            },
        };
    },
    methods: {
        sortObject(data) {
            return Object.entries(data).sort(
                (a, b) => Math.abs(b[1]) - Math.abs(a[1])
            );
        },
        resortObject(data) {
            const temp = data.sort((a, b) => b[1] - a[1]);
            return temp;
        },
        processData(data) {
            let exposureData = this.sortObject(data);
            if (this.topNumber !== "All") {
                exposureData = exposureData.splice(0, this.topNumber);
            }

            exposureData = this.resortObject(exposureData);

            const xValues = [];
            const yValues = [];
            let count = 0;

            for (let i = 0; i < exposureData.length; i++) {
                if (count === this.topnumber) break;
                const item = exposureData[i];
                xValues.push(item[0]);
                yValues.push(item[1].toFixed(2));
                count += 1;
            }
            this.option.yAxis.data = xValues;
            this.option.series[0].data = yValues;
            if (this.chart && this.chart.setOption) {
                this.chart.setOption(this.option);
                this.chart.resize();
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (!this.$refs.exposureChart) return;
            this.chart = echarts.init(this.$refs.exposureChart);
            if (
                this.exposureData &&
                Object.keys(this.exposureData).length > 0
            ) {
                this.processData(this.exposureData);
            }
        });
        this.resizeHandler = () => {
            if (this.chart) {
                this.chart.resize();
            }
        };
        window.addEventListener("resize", this.resizeHandler);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeHandler);
    },
};
</script>

<style scoped>
.exposure-chart-wrapper {
    height: 100%;
}
.chart {
    width: 100%;
    height: 100%;
}
</style>
